import LoggedIn from "./LoggedIn";

export default LoggedIn;
